export default function isAuthorizedManagerCourse(user, courseId) {
  const features = user?.meta?.features;
  if (!features?.canManageCourses) return null;

  return features?.authorizedManagerCourseIds?.includes(courseId);
}
